<template lang="pug">
div
  //- Mobile: horizontal scrollable tabs
  div(v-if="$vuetify.breakpoint.mobile")
    div.overflow-x-auto
      div.d-flex.align-center.justify-start(style="width: max-content;")
        template(v-for="menu in sideMenu")
          div(:key="menu.id")
            router-link(:to="menu.to" v-slot="{ href, navigate, isActive }")
              div
                .px-4.py-2
                  a.text-sm.font-semibold.capitalize.no-underline(:href="href" @click="navigate" :class="isActive ? '' : 'neutral500--text'") {{ menu.title }}
                .bar-active(v-if="isActive")
    div.neutral300
      v-container.pa-5(style="max-width: 1600px")
        router-view(ref="childView" @update:footer="onFooterUpdate")

  //- Desktop: side panel layout
  .d-flex.flex-column(v-else :style="{ minHeight: minScreenHeight }")
    .d-flex.flex-grow-1
      //- Left Panel Navigation
      .pa-8.d-flex.flex-column(:style="$vuetify.breakpoint.xlOnly ? 'width: 20vw; min-width: 20vw;' : 'width: 350px; min-width: 350px;'")
        div(v-for="menu in sideMenu" :key="menu.id")
          router-link(:to="menu.to" v-slot="{ navigate, isActive }")
            .yz-medium-body-md.px-3.py-2.mb-2(@click="navigate" :class="isActive ? 'selected-bg round-sm' : 'cursor-pointer text-neutral-500'") {{ menu.title }}

      //- Main Content
      .flex-grow-1
        v-container
          //- Header
          .yz-heading-5.mt-5 General settings

          yz-divider.mb-4.mt-2

          router-view(ref="childView" @update:footer="onFooterUpdate")

  //- Footer
  .footer-bar(v-if="showFooter")
    .d-flex.align-center.justify-end.px-6.py-3
      yz-btn(label="Save" size="lg" :loading="footerLoading" :disabled="footerDisabled" @click="onFooterSave")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      displaySize: 'ui/getDisplaySize'
    }),
    minScreenHeight() {
      switch (this.displaySize) {
        case 'xx-small': return 'calc(149vh - 72px)'
        case 'x-small': return 'calc(133vh - 72px)'
        case 'small': return 'calc(125vh - 72px)'
        case 'medium': return 'calc(111vh - 72px)'
        case 'large': return 'calc(100vh - 72px)'
        case 'x-large': return 'calc(91vh - 74px)'
        default: return 'calc(100vh - 72px)'
      }
    }
  },
  data: () => ({
    sideMenu: [
      { id: 'price-tier', to: '/admin/hq/inventory/settings/price-tier', title: 'Price tier' },
      { id: 'payment-methods', to: '/admin/hq/inventory/settings/payment-methods', title: 'Payment methods' },
      { id: 'medicine-details', to: '/admin/hq/inventory/settings/medicine-details', title: 'Medicine details' },
      { id: 'suppliers', to: '/admin/hq/inventory/settings/suppliers', title: 'Suppliers' },
      { id: 'inventory-creation', to: '/admin/hq/inventory/settings/inventory-creation', title: 'Inventory, services & packages' }
    ],
    showFooter: false,
    footerLoading: false,
    footerDisabled: true
  }),
  methods: {
    onFooterUpdate({ show, loading, disabled }) {
      if (show !== undefined) this.showFooter = show
      if (loading !== undefined) this.footerLoading = loading
      if (disabled !== undefined) this.footerDisabled = disabled
    },
    onFooterSave() {
      const childView = this.$refs.childView
      if (childView && typeof childView.saveSettings === 'function') {
        childView.saveSettings()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-bar {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid #eee;
  z-index: 10;
}

.overflow-x-auto {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
}

.bar-active {
  height: 2px;
  width: 100%;
  margin: auto;
  margin-top: -2px;
  background-color: #333;
}
</style>
